export const MANUSCRIPT_V1_API_URL_PREFIX = '/suite/api/manuscript/v1';
export const ROUTE_MANUSCRIPT_PREVIEW = 'manuscript-preview';
export const MANUSCRIPT_PREVIEW_STORAGE_KEY = 'manuscript_preview_data';
export const LESSON_OUTLINE_COLLAPSED_PREFERENCE = 'lesson_outline_collapsed';
export const COMMENTS_COLLAPSED_PREFERENCE = 'comments_collapsed';
